import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyBrandPage = loadable(
  () =>
    import(
      /* webpackChunkName: "content/catalog/brandpage" */
      '.'
    ),
);
